<app-review-section
  [title]="'facilities-data.fireplace-title' | translate"
  [tooltip]="'tooltips.facilities-data.fireplace-title' | translate"
  [sectionId]="sectionIdentifier.TechnicalData_FireplaceAndVentilation"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"
  [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper">
  <span class="component-container base-data-container">
    <form [formGroup]="firePlaceSystemFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="form-background">
        <div class="flex-parent">
          <div
            [class.flex-bottom-margin]="i > 0"
            formArrayName="arr1"
            *ngFor="let data1 of arr1?.controls; let i = index"
            class="flex-child">
            <div
              [class.flex-position]="x === 2 && i === 0"
              class="ui-g-3 flex-elements"
              *ngFor="let label of firePlaceData | slice : 0 : 4; let x = index"
              [formGroupName]="i">
              <span class="label-margin" *ngIf="i === 0" [style.width]="x === 2 ? '12rem' : 'unset'">
                {{ (getTableLabel(label?.label1) | translate).replace('m3', 'm³') }}
              </span>
              <input
                [readonly]="isReadOnly"
                class="text-width"
                type="text"
                [formControlName]="label?.label1"
                pInputText
                [appNumber]="x === 3" />
            </div>
          </div>
        </div>
        <div class="ui-g-12 border-line"></div>
        <div class="flex-parent">
          <div
            [class.flex-bottom-margin]="j > -1"
            formArrayName="arr2"
            *ngFor="let data2 of arr2?.controls; let j = index"
            class="flex-child">
            <div
              [style.align-self]="j === 0 && k === 4 ? 'center' : 'baseline'"
              [class.ui-g-3]="k !== 4"
              ui-md-2
              class="flex-elements"
              *ngFor="let label of firePlaceData | slice : 4; let k = index"
              [formGroupName]="j">
              <span class="label-margin" *ngIf="label?.label1 && j === 0">{{ getTableLabel(label?.label1) | translate }}</span>
              <p-dropdown
                [readonly]="isReadOnly"
                *ngIf="k === 1"
                [options]="fuelTypeOptions"
                [formControlName]="label?.label1"
                id="fireplace-{{ k }}"
                styleClass="netz-small-dropdown"
                placeholder="-Select-"
                (onChange)="selectDropdownValue($event.value, j)">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">{{ 'lookup.' + fuelType + '.options.' + item['value'] + '.name' | translate }}</span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">{{ 'lookup.' + fuelType + '.options.' + option['value'] + '.name' | translate }}</span>
                  </div>
                </ng-template>
              </p-dropdown>
              <ng-container *ngIf="k === 1 && data2.value?.fuel === 'other'">
                <label [class.required]="data2.value?.fuel === 'other'" class="fuel-margin">
                  {{ 'facilities-data.form-fields.fuel-type' | translate }}
                </label>
                <input [readonly]="isReadOnly" class="text-width" type="text" formControlName="otherFuelType" pInputText />
              </ng-container>
              <input
                [readonly]="isReadOnly"
                *ngIf="k !== 4 && k !== 1"
                class="text-width"
                type="text"
                [formControlName]="label.label1"
                pInputText
                [appNumber]="k === 0 || k === 2 || k === 3"
                (keyup)="furnaceInputData(label.label1)" />
              <button
                *ngIf="k === 4 && (j > 0 || arr2.length > 1) && !isReadOnly"
                (click)="deleteCell(j)"
                [class.btn-position]="j === 0 && data2.value?.fuel === 'other'"
                class="pi pi-trash pointer-cursor"></button>
            </div>
          </div>
        </div>
        <div class="ui-g flex-sum">
          <div class="ui-g-6"></div>
          <div class="ui-g-3">
            <input
              class="text-width"
              [style.margin-left]="arr1.length > 1 ? '-0.7rem' : '0'"
              type="text"
              [appNumber]="true"
              [readonly]="isReadOnly"
              formControlName="heatSum"
              pInputText />
          </div>
          <div class="ui-g-3">
            <input
              class="text-width"
              [style.margin-left]="arr1.length > 1 ? '-1rem' : '0'"
              type="text"
              [appNumber]="true"
              [readonly]="isReadOnly"
              formControlName="setHeatSum"
              pInputText />
          </div>
        </div>
        <div class="ui-g-4 add-button-row" *ngIf="!isReadOnly">
          <button (click)="addCell()" class="pi pi-plus plus-icon" id="add-cell" tabindex="0" appEnterClick></button>
          <label class="ui-g-5 field-label" for="add-cell">{{ 'facilities-data.form-fields.addCell' | translate }}</label>
        </div>
        <div class="ui-g-12 checkbox-rows">
          <div class="ui-g-2">{{ 'facilities-data.form-fields.firing-device' | translate }} :</div>
          <div
            [class]="i === 1 || i === 3 ? 'ui-g-3' : 'ui-g-2'"
            *ngFor="let data of firePlaceCheckboxLabels | slice : 0 : 4; let i = index">
            <p-checkbox
              appEnterClick
              [readonly]="isReadOnly"
              binary="true"
              [formControlName]="data.controlName"
              id="{{ data.label }}"
              [label]="getCheckBoxLabel(data.label) | translate"></p-checkbox>
            <label for="{{ data.label }}" class="ui-g-5"></label>
          </div>
        </div>
        <div class="ui-g-12 checkbox-rows">
          <div class="ui-g-2"></div>
          <div [class]="i === 1 ? 'ui-g-3' : 'ui-g-2'" *ngFor="let data of firePlaceCheckboxLabels | slice : 4 : 7; let i = index">
            <p-checkbox
              appEnterClick
              [readonly]="isReadOnly"
              binary="true"
              *ngIf="i !== 2"
              [formControlName]="data.controlName"
              id="{{ data.label }}"
              [label]="getCheckBoxLabel(data.label) | translate"></p-checkbox>
            <label for="{{ data.label }}" class="ui-g-5"></label>
            <p-checkbox
              appEnterClick
              [readonly]="isReadOnly"
              binary="true"
              *ngIf="i === 2"
              [formControlName]="data.controlName"
              id="{{ data.label }}"
              [label]="getCheckBoxLabel(data.label) | translate"
              (onChange)="openAirCheckBox($event.checked, false)"></p-checkbox>
            <label for="{{ data.label }}" class="ui-g-5"></label>
          </div>
        </div>
        <ng-container
          *ngIf="
            !firePlaceSystemFG.get('airSupplyOpenAirCheckbox')?.value &&
            isHeatValueGreaterThan35 &&
            firePlaceSystemFG?.get('roomVentilation')
          ">
          <div class="ui-g-12">
            <div class="ui-g-8">
              <label class="ui-g-5 field-label" [class.required]="firePlaceSystemFG?.get('roomVentilation')" for="room-ventilation">
                {{ 'facilities-data.form-fields.room-ventilation' | translate }}
              </label>
            </div>
          </div>
          <div class="ui-g-12 room-margin" *ngIf="firePlaceSystemFG?.get('roomVentilation')">
            <div class="ui-g-3" *ngIf="firePlaceSystemFG?.get('roomVentilation')">
              <p-dropdown
                [readonly]="isReadOnly"
                [options]="combustionBoilerOptions"
                [formControl]="firePlaceSystemFG?.controls['roomVentilation']"
                id="room-ventilation"
                placeholder="-Select-"
                (onChange)="roomVentilationChange($event.value)">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{ 'lookup.' + combustionBoiler + '.options.' + item['value'] + '.name' | translate }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + combustionBoiler + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div class="ui-g-3" *ngIf="firePlaceSystemFG?.get('roomVentilationValueincm')">
              <input
                [readonly]="isReadOnly"
                type="text"
                class="usability-width"
                id="measure"
                [formControl]="firePlaceSystemFG?.controls['roomVentilationValueincm']"
                pInputText
                [appNumber]="true" />
              <span>{{ centiMeterSquare | translate }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </span>
</app-review-section>
